import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL } from 'consts/zIndex'
import styled from 'styled-components'

export const ResizeLineWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  cursor: row-resize;
  height: 16px;
  transform: translateY(-50%);
  width: 100%;
  z-index: ${Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL};
  transition: opacity 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${COLORS.primaryDark};
    opacity: 0;
  }

  &:hover {
    &::after {
      opacity: 1;
    }
  }
`

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 280px;
  flex-shrink: 0;
  background-color: ${COLORS.surface};
  /* Same rounding as the Sidebar shell card. No z-index: it was only for a
     since-removed drop shadow, and it painted the timeline over the header's
     user dropdown on mobile. */
  border-radius: 16px;
  box-sizing: border-box;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    /* Full-bleed flat panel on mobile, divided from the canvas by a border. */
    border-radius: 0;
    border-top: 1px solid ${COLORS.borderLayout};
  }
`
